import React from "react";
import "../scss/_pageNotFound.scss";
import { useTranslation } from "react-i18next";
import { RiErrorWarningFill } from "@remixicon/react";
import { motion } from "framer-motion";

function notFound() {
    const { t } = useTranslation();
    return (
        <div className="error-container">
            <div className="noPage">
                <RiErrorWarningFill className="exclamation-point" />
                <div className="error-text">
                    <h1> {t("PageNotFound")} </h1>
                    <p>{t("UhOh")}</p>
                </div>
                <motion.a href="/" className="home-button" whileHover={{ scale: 1.05 }}>
                    {t("goHome")}
                </motion.a>
            </div>
        </div>
    );
}
export default notFound;
